module.exports = __webpack_public_path__ + "img/iosStep-4.e7c70d1e.webp";